import delegateEvent from '../utilities/delegateEvent';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const setup = () => {
  // delegateEvent(
  //   document,
  //   'click',
  //   '[data-w-video-control="play"]',
  //   (event, element) => {
  //     event.preventDefault();

  //     const container = element.closest('[data-w-video]');
  //     const video = container.querySelector('video');

  //     if (video.paused === true) {
  //       container.classList.add('w-is-played-once');
  //       video.play();
  //       video.setAttribute('controls', 'controls');
  //       element.disabled = true;
  //     }
  //   }
  // );

  delegateEvent(
    document,
    'click',
    '[data-w-video-control="restart"]',
    (event, element) => {
      event.preventDefault();

      const container = element.closest('[data-w-video]');
      const video = container.querySelector('video');

      if (video.paused === true) {
        container.classList.remove('w-is-ended');
        video.currentTime = 0;
        video.play();
        container.classList.add('w-is-playing');
      }
    }
  );

  const videos = document.querySelectorAll('[data-w-video] video');
  videos.forEach((video) => {
    // if (video.getAttribute('data-w-video-mode') === 'momentarily') {
    //   video.addEventListener('canplaythrough', (event) => {
    //     const container = video.closest('[data-w-video]');
    //     container.classList.add('w-is-playable');
    //     container.classList.add('w-is-playing');
    //   });
    //   video.play();
    // }

    video.addEventListener('ended', (event) => {
      // console.log('ended', video);
      const container = video.closest('[data-w-video]');
      container.classList.remove('w-is-playing');
      container.classList.add('w-is-ended');
    });
  });

  const autoplayVideos = document.querySelectorAll(
    '[data-w-video] video[data-w-video-autoplay="1"]'
  );
  autoplayVideos.forEach((video) => {
    const container = video.closest('[data-w-video]');

    gsap.to(video, {
      scrollTrigger: {
        trigger: container ?? video,
        start: 'top bottom',
        end: 'bottom top',
        onEnter: () => {
          if (video) video.play();
        },
        onEnterBack: () => {
          if (video) video.play();
        },
        onLeaveBack: () => {
          if (video) video.pause();
        },
        onLeave: () => {
          if (video) video.pause();
        },
      },
    });
  });
};

export default function Video() {
  return {
    init: () => {
      setup();
    },
  };
}
